<button class="btn back-button link" (click)="goBack()"></button>
<div class="google-map" #gmap></div>